class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.autoCloseTimer = null;
    this.notification.addEventListener('pointerenter', () => this.pauseAutoClose());
    this.notification.addEventListener('pointerleave', () => this.startAutoClose());
    this.notification.addEventListener('focusin', (event) => {
      if (event.target !== this.notification) this.pauseAutoClose();
    });
    this.notification.addEventListener('focusout', () => {
      setTimeout(() => this.startAutoClose(), 0);
    });
    this.notification.addEventListener('keydown', () => this.pauseAutoClose());
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.pauseAutoClose();
      else this.startAutoClose();
    });
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    // Focus must work even when reduced motion disables the transition.
    requestAnimationFrame(() => {
      if (this.notification.classList.contains('active')) {
        trapFocus(this.notification);
        this.startAutoClose();
      }
    });

    document.body.addEventListener('click', this.onBodyClick);
  }

  pauseAutoClose() {
    clearTimeout(this.autoCloseTimer);
  }

  startAutoClose() {
    this.pauseAutoClose();
    const focusedControl = this.notification.contains(document.activeElement) && document.activeElement !== this.notification;
    if (!this.notification.classList.contains('active') || document.hidden || this.notification.matches(':hover') || focusedControl) return;
    this.autoCloseTimer = setTimeout(() => this.close(), 6000);
  }

  close() {
    this.pauseAutoClose();
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header && typeof this.header.reveal === 'function') this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
